import { useQuery } from "@apollo/client"
import { GET_ACTIVE_TOURNAMENTS_WITH_ROUNDS } from "../queries/activeTournamentsWithRounds"
import type { ActiveTournamentWithRounds } from "../types/activeTournamentsWithRounds"

interface QueryResult {
  ActiveTournamentsWithMyRounds: {
    status: { success: boolean; name: string; detail: string }
    Tournaments: ActiveTournamentWithRounds[]
  }
}

export const useActiveTournamentsWithRounds = (personId: number | undefined) => {
  const { data, loading, error, refetch } = useQuery<QueryResult>(
    GET_ACTIVE_TOURNAMENTS_WITH_ROUNDS,
    {
      variables: {
        input: {
          limit: 5,
          statusId: [2, 3, 4, 5, 6],
        },
      },
      errorPolicy: "all",
      skip: !personId,
    },
  )

  return {
    tournaments: data?.ActiveTournamentsWithMyRounds?.Tournaments ?? [],
    loading,
    error,
    refetch,
  }
}
